var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconMediaOpen = function SvgIconMediaOpen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00008 3.83341C6.00008 4.06717 6.04018 4.29156 6.11388 4.50008H4.00008V12.5001H12.0001V10.3863C12.2086 10.46 12.433 10.5001 12.6667 10.5001C12.9005 10.5001 13.1249 10.46 13.3334 10.3863V12.5001C13.3334 13.2365 12.7365 13.8334 12.0001 13.8334H4.00008C3.2637 13.8334 2.66675 13.2365 2.66675 12.5001V4.50008C2.66675 3.7637 3.2637 3.16675 4.00008 3.16675H6.11388C6.04018 3.37527 6.00008 3.59966 6.00008 3.83341Z",
    fill: "#0069D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66675 3.16675C8.29856 3.16675 8.00008 3.46522 8.00008 3.83341C8.00008 4.2016 8.29856 4.50008 8.66675 4.50008H11.0573L7.52868 8.02868C7.26833 8.28903 7.26833 8.71114 7.52868 8.97149C7.78903 9.23184 8.21114 9.23184 8.47149 8.97149L12.0001 5.44289V7.83341C12.0001 8.2016 12.2986 8.50008 12.6667 8.50008C13.0349 8.50008 13.3334 8.2016 13.3334 7.83341V3.83341C13.3334 3.46522 13.0349 3.16675 12.6667 3.16675H8.66675Z",
    fill: "#0069D0"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMediaOpen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-media-open.b73a21d7.svg";
export { ForwardRef as ReactComponent };